var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPt(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M21.7 0h32v40h-32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#060",
    d: "M.3 0h21.4v40H.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M28.6 25.5a41 41 0 0 1-15-9l.6-1.1a58 58 0 0 0 15 9z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M14 15.2c-.2.7 3.3 2.8 7.4 5.4a29 29 0 0 0 8 3.8l.2-.2h-.4c-1.1-.3-4-1.6-7.7-3.8a35 35 0 0 1-7.3-5.4h0zm14.7 10.4h-.3c-1 0-4-1.6-7.7-3.7-4.2-2.5-7.6-4.8-7.2-5.4v-.2h0c-.3 1 7 5.1 7.3 5.4 4.2 2.5 7.7 4 8 3.7z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M21.7 17.3c2.7 0 6-.4 7.9-1.2l-.4-.6a22 22 0 0 1-7.5 1q-5.5 0-7.5-1.2l-.4.8q3.4 1.4 7.9 1.2",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    fillRule: "evenodd",
    d: "M29.7 16.2s-1.3.5-3.1.8a32 32 0 0 1-9.6 0q-3-.5-3.3-.8V16l3.3.9a34 34 0 0 0 9.5 0q3-.6 3-1zm-.4-.7q-.3.2-3 .8a32 32 0 0 1-9 0q-2.9-.5-3.2-.8v-.2q.5.4 3.1.8a32 32 0 0 0 9.1 0q2.7-.6 3-.8zm-16.4 5a24 24 0 0 0 8.8 1.4 25 25 0 0 0 8.8-1.3v-1c-.5.8-5 1.5-8.9 1.5s-7.5-.6-8.8-1.4z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M12.9 20.5a24 24 0 0 0 8.8 1.4 25 25 0 0 0 8.8-1.3v-1c-.5.8-5 1.5-8.9 1.5s-7.5-.6-8.8-1.4zm17-4.4q-.4.4-3.2.9a32 32 0 0 1-9.6 0q-3-.5-3.3-.8V16l3.3.9a34 34 0 0 0 9.5 0q3-.6 3-1zm-.5-.6q-.3.2-3 .8a32 32 0 0 1-9 0q-2.9-.5-3.2-.8v-.2q.5.4 3.1.8a32 32 0 0 0 9.1 0q2.7-.6 3-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    fillRule: "evenodd",
    d: "M30.6 20.4v.2q-.6.5-3.5 1a36 36 0 0 1-14.3-1v-.2c.8.5 3 .9 3.7 1a34 34 0 0 0 14-1m0-.8v.2q-.6.5-3.5 1a36 36 0 0 1-10.7 0 13 13 0 0 1-3.6-1v-.2c.8.5 3 1 3.7 1a34 34 0 0 0 14-1m-9 5.8c-3.7 0-7-1-7.7-1.2l.5.7q3.5 1.3 7.3 1.2 4.4 0 7.2-1.1l.5-.9a27 27 0 0 1-7.8 1.3",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M21.7 25.4c-3.8 0-7.1-1-7.8-1.2l.5.7q3.5 1.3 7.3 1.2 4.4 0 7.2-1.1l.5-.9a27 27 0 0 1-7.8 1.3m9-5v.2q-.6.5-3.5 1a36 36 0 0 1-14.3-1v-.2c.8.5 3 .9 3.7 1a34 34 0 0 0 14-1m0-.8v.2q-.6.5-3.5 1a36 36 0 0 1-10.7 0 13 13 0 0 1-3.6-1v-.2c.8.5 3 1 3.7 1a34 34 0 0 0 14-1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m29 24.8-.2.3-2.7.7q-2.2.4-4.5.4c-3.3 0-6-.7-7.4-1.2v-.2h.1a24 24 0 0 0 14.7 0m.5-.8-.1.3q-.8.4-3.5.8a29 29 0 0 1-12-.8l-.1-.2q3.8 1 7.9 1.1c2.1 0 3-.1 4.2-.3q3-.6 3.4-.8 0 0 0 0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M29.6 19.8c0 2.5-1.3 4.8-2.3 5.7a8 8 0 0 1-5.7 2.4 8 8 0 0 1-5.5-2.3 8 8 0 0 1-2.3-5.7 8 8 0 0 1 2.8-5.9q2.3-2 5.3-1.9a8 8 0 0 1 6 3q1.4 1.7 1.7 4.7m-8-8.5a8.8 8.8 0 0 1 8.2 12 8.8 8.8 0 1 1-8.2-12",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M21.7 11.2a8.8 8.8 0 0 1 0 17.6 8.8 8.8 0 0 1 0-17.6M13 20a8.6 8.6 0 1 0 17.2 0c0-4.7-4-8.6-8.6-8.6A8.6 8.6 0 0 0 13 20",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M21.7 12a8 8 0 0 1 5.7 13.7 8 8 0 0 1-5.7 2.4 8 8 0 0 1 0-16.1m-7.9 8c0 4.3 3.6 7.9 7.9 7.9s7.8-3.6 7.8-7.9a7.9 7.9 0 0 0-13.4-5.6 8 8 0 0 0-2.3 5.6",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M22 11.2h-.7v17.7h.7z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M22 11h.1v18H22zm-.8 0h.2v18h-.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M30.5 20.4v-.7l-.6-.5-3-.8-4.3-.4-5.3.2-3.7 1-.8.5v.6l2-.8 4.5-.7h4.3l3.2.3 2.2.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M21.7 18.7q3 0 5.7.4 2.5.6 3.2 1.3v.2c-.5-.6-2-1-3.3-1.3a31 31 0 0 0-11.4 0c-1.3.3-3 .8-3.2 1.3v-.2q.4-.7 3.2-1.2 2.4-.5 5.8-.6m0-.8q2.9 0 5.7.5 2.5.4 3.2 1.2v.2c-.5-.5-2-1-3.3-1.2a31 31 0 0 0-11.4 0c-1.2.2-3 .8-3.2 1.2v-.2q.4-.6 3.2-1.2 2.4-.5 5.8-.5m0-3.9c3.2 0 6 .5 7.4 1.2l.4.8c-1.1-.6-4.2-1.2-7.9-1.2-3 0-6.2.4-7.8 1.2l.6-1c1.3-.6 4.4-1 7.2-1",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    fillRule: "evenodd",
    d: "M21.7 14.7q2.6 0 5 .4c1.4.2 2.7.6 2.9.8l.1.2q-.7-.4-3-.8t-5-.4q-3.1 0-5.2.4a9 9 0 0 0-2.8.8l.2-.2q.7-.5 2.6-.8a30 30 0 0 1 5.2-.4m0-.7q2.8 0 4.9.3a8 8 0 0 1 2.5.8l.3.4c-.4-.4-1.7-.8-2.9-1a31 31 0 0 0-9.8 0q-1.2.2-2.5.8l.2-.3 2.3-.7q2.4-.4 5-.3m4.3 9.7a23 23 0 0 0-4.3-.4c-5.5.1-7.3 1.2-7.5 1.5l-.4-.7c1.4-1 4.4-1.6 7.9-1.5q2.7 0 4.7.4z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M26 23.7a23 23 0 0 0-4.3-.4c-5.5.1-7.3 1.2-7.5 1.5l-.4-.7c1.4-1 4.4-1.6 7.9-1.5q2.7 0 4.7.4zm-4.3-9q2.6 0 5 .4c1.4.2 2.7.6 2.9.8l.1.2q-.7-.4-3-.8t-5-.4q-3.1 0-5.2.4a9 9 0 0 0-2.8.8l.2-.2q.7-.5 2.6-.8a30 30 0 0 1 5.2-.4m0-.7q2.8 0 4.9.3a8 8 0 0 1 2.5.8l.3.4c-.4-.4-1.7-.8-2.9-1a31 31 0 0 0-9.8 0q-1.2.2-2.5.8l.2-.3 2.3-.7q2.4-.4 5-.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M21.6 23.2q2.3 0 4.5.4l-.1.2q-2-.4-4.4-.4-3 0-5.8.7c-.6.2-1.5.5-1.6.8v-.1q0-.4 1.6-.9 3-.7 5.8-.7m.1-.7q2.4 0 4.8.4l-.1.2a25 25 0 0 0-10.8.3c-.6.2-1.7.6-1.8.9V24c0-.3.9-.7 1.8-.9q3-.8 6.1-.7",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m29.5 24.2-.7 1-1.9-1.6-4.9-3.3-5.5-3-2.8-1 .6-1.2h.2l1.7.4 6 3 3.3 2.1 2.8 2 1.2 1.4z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M13.6 16.3c.5-.3 4.1 1.3 8 3.6 3.8 2.4 7.5 5 7.2 5.5l-.1.2h0v-.3c-.2-.5-2.8-2.6-7.2-5.2-4.2-2.5-7.7-4-8-3.6zm16 7.9c.3-.6-3.1-3.2-7.4-5.7s-7.4-4-8-3.5l-.1.3q0 0 0 0l.4-.2q1.7 0 7.7 3.6c1.7 1 7.3 4.6 7.3 5.6v.1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M16.4 21a5 5 0 0 0 1.5 3.7 5.2 5.2 0 0 0 9-3.7v-7H16.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "red",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M16.6 21a5 5 0 0 0 1.5 3.5 5 5 0 0 0 8.2-1.6l.4-1.9v-6.8H16.6zm8-4.8V21a3 3 0 0 1-.8 2.1 3 3 0 0 1-4.3 0 3 3 0 0 1-.9-2.1v-4.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    d: "M17.2 16q.2-.7.4-.7t.4.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m17 15.4-.1.5h.3q.2-.5.4-.5.2-.1.4.5h.3v-.6zm-.2.5h1.6v.2h-1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    d: "m17.4 16 .2-.5.2.4zm-.5-.9h1.4v.1H17m0 .1h1.4v.1zm.5-.9h.5v.2h-.5zm.4.2v.6h-.4v-.6z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M17.8 14.5v.6h-.4v-.6h.4m-.4 1.4.2-.4.2.4zm-.5-.8h1.4v.1H17Zm0 .1h1.4v.1zm.5-.9h.5v.2h-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M17.3 14.8v.3H17v-.3zm1 0v.3h-.4v-.3zm-1.4-.2h.5v.2h-.5zm.9 0h.5v.2h-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    d: "M17.6 14.7v.2zm-.5.3q0-.1 0 0m.9 0q0-.1.1 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    d: "M17.2 20q.2-.5.4-.5.2-.1.4.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m17 19.5-.1.5h.3q.2-.5.4-.5.2-.1.4.5h.3v-.5zm-.2.5h1.6v.1h-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    d: "M17.4 20q.1-.4.2-.3l.2.3zm-.5-.8h1.4v.1H17m0 .2h1.4zm.5-1h.2v.1h.3v.1h-.5zm.4.3v.5h-.4v-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M17.8 18.7v.5h-.4v-.5h.4m-.4 1.3q.1-.4.2-.3l.2.3zm-.5-.8h1.4v.1H17Zm0 .2h1.4zm.5-1h.2v.1h.3v.1h-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M17.3 19v.2H17V19zm1 0v.2h-.4V19zm-1.4-.3h.5v.2h-.5zm.9 0h.5v.2h-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    d: "M17.6 18.8v.2zm-.5.2v.1m.9-.1h.1v.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    d: "M18.8 24.4q-.3-.6-.1-.7 0-.2.7.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m18.2 24.1.4.5.2-.3q-.3-.5-.1-.6 0-.2.6.1l.3-.3-.5-.3zm.3.5 1.1-1h.1l-1 1.1h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    d: "M19 24.2q-.3-.3-.2-.4l.4.1zm-1-.2 1-1h.1l-1 1.1q-.2 0 0 0m.1 0 1-.9v.1l-.9 1q-.2 0 0-.1m-.3-.9h.1v-.2h.1l.1-.1h.1v.1l-.2.3H18m.4-.1.4.4-.2.2-.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m18.2 23 .4.4-.2.2-.4-.4.2-.2m.7 1.2q-.1-.3 0-.4l.3.1zM18 24l1-1h.1l-1 1.1q-.2 0 0 0zm.1 0 1-.9v.1l-.9 1q-.2 0 0-.1Zm-.3-.9h.1v-.2h.1l.1-.1h.1v.1l-.2.3h-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m18 23.5.3.2-.2.3-.3-.2zm.8-.7.2.2-.3.3-.2-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M17.6 23.6h.2v-.1h.1v-.2l.2.1-.3.4zm.7-.6v-.1h.1l.1-.1h.1v-.1h.2v.1l-.3.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    d: "M18.2 23.3v-.1l.2.1zm-.2.4h.1v.1m.6-.8h.1v.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    d: "M21.3 16q.2-.7.4-.7t.3.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M21 15.4v.5h.3q.2-.5.4-.5.2-.1.3.5h.4v-.6zm0 .5h1.4v.2H21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    d: "m21.5 16 .2-.5.2.4zm-.6-.9h1.5v.1zm0 .1h1.5v.1H21m.5-.9h.5v.2h-.4zm.4.2v.6h-.3v-.6z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M21.8 14.5v.6h-.3v-.6h.3m-.3 1.4.2-.4.2.4zm-.6-.8h1.5v.1zm0 .1h1.5v.1H21Zm.5-.9h.5v.2h-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M21.4 14.8v.3H21v-.3zm.9 0v.3H22v-.3zm-1.3-.2h.4v.2H21zm.9 0h.5v.2h-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    d: "M21.6 14.7h.1v.2zm-.4.3q0-.1 0 0m.9 0q0-.1 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    d: "M26 16q-.1-.7-.3-.7t-.4.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M26.4 15.4v.5h-.3q-.2-.5-.4-.5-.1-.1-.4.5H25v-.6zm0 .5H25v.2h1.6V16Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    d: "m26 16-.3-.5-.2.4zm.4-.9H25v.1zm0 .1H25v.1zm-.4-.9h-.5v.2h.4zm-.5.2v.6h.4v-.6z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M25.5 14.5v.6h.4v-.6h-.4M26 16l-.2-.4-.2.4zm.5-.8H25v.1h1.4Zm0 .1H25v.1h1.4Zm-.4-.9h-.5v.2h.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M26 14.8v.3h.4v-.3zm-1 0v.3h.4v-.3zm1.4-.2H26v.2h.4zm-.9 0H25v.2h.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    d: "M25.7 14.7v.2zm.5.3q0-.1 0 0m-.9 0q0-.1-.1 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    d: "M26 20q-.1-.5-.3-.5-.2-.1-.4.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M26.4 19.5v.5h-.3q-.2-.5-.4-.5-.1-.1-.4.5H25v-.5zm0 .5H25l-.1.1h1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    d: "M26 20q-.2-.4-.3-.3l-.2.3zm.4-.8H25v.1h1.4m0 .2H25zm-.4-1h-.4v.1h-.1v.1h.4zm-.5.3v.5h.4v-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M25.5 18.7v.5h.4v-.5h-.4M26 20q-.1-.4-.2-.3l-.2.3zm.5-.8H25v.1h1.4Zm0 .2H25h1.4Zm-.4-1h-.4v.1h-.1v.1h.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M26 19v.2h.4V19zm-1 0v.2h.4V19zm1.4-.3H26v.2h.4zm-.9 0H25v.2h.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    d: "M25.7 18.8v.2zm.5.2v.1m-.9-.1v.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    d: "M24.5 24.4q.3-.6.1-.7 0-.2-.7.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m25.1 24.1-.3.5-.3-.3q.3-.5.1-.6 0-.2-.6.1l-.3-.3.5-.3zm-.3.5-1.1-1q-.2 0 0 0l1 1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    d: "M24.4 24.2q.2-.3.1-.4l-.4.1zm1-.2-1.1-1q-.1 0 0 0l1 1.1m-.2 0-1-.9v.1l1 1zm.4-.9h-.2V23h-.1v-.1H25v.1l.3.3zM25 23l-.4.4.2.2.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m25 23-.3.4.2.2.4-.4-.2-.2m-.7 1.2q.2-.3.1-.4l-.4.1zm1-.2-1.1-1q-.1 0 0 0l1 1.1Zm-.2 0-1-.9v.1l1 1zm.4-.9h-.2v-.2h-.1v-.1H25v.1l.3.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m25.2 23.5-.2.2.3.3.2-.2zm-.6-.7-.2.2.2.3.2-.2zm1.1.8h-.2v-.1h-.1v-.2l-.2.1.3.4zM25 23v-.1h-.1v-.1h-.2v-.1h-.1v.1l.2.3h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    d: "M25.1 23.3v-.1l-.1.1zm.2.4h-.1v.1zm-.7-.7v.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#039",
    d: "m21 20.2.4.7h.3q.3 0 .4-.2t.2-.5v-1H21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21.3 19.8a.1.1 0 1 0 0-.3.1.1 0 0 0 0 .3m.7 0a.1.1 0 1 0 0-.3.1.1 0 0 0 0 .3m-.3.3a.1.1 0 1 0 0-.3.1.1 0 0 0 0 .3m-.4.4a.1.1 0 1 0 0-.3.1.1 0 0 0 0 .3m.7 0a.1.1 0 1 0 0-.3.1.1 0 0 0 0 .3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#039",
    d: "m21 18 .4.6h.3q.3 0 .4-.2t.2-.5v-1H21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21.3 17.4a.1.1 0 1 0 0-.2.1.1 0 0 0 0 .2m.7 0a.1.1 0 1 0 0-.2.1.1 0 0 0 0 .2m-.3.4a.1.1 0 1 0 0-.3.1.1 0 0 0 0 .3m-.4.4a.1.1 0 1 0 0-.3.1.1 0 0 0 0 .3m.7 0a.1.1 0 1 0 0-.3.1.1 0 0 0 0 .3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#039",
    d: "m19.2 20.2.4.7h.2q.3 0 .5-.2l.2-.5v-1h-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.5 19.8a.1.1 0 1 0 0-.3.1.1 0 0 0 0 .3m.7 0a.1.1 0 1 0 0-.3.1.1 0 0 0 0 .3m-.4.3a.1.1 0 1 0 0-.3.1.1 0 0 0 0 .3m-.3.4a.1.1 0 1 0 0-.3.1.1 0 0 0 0 .3m.7 0a.1.1 0 1 0 0-.3.1.1 0 0 0 0 .3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#039",
    d: "m22.9 20.2.4.7h.2q.3 0 .5-.2l.2-.5v-1h-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M23.2 19.8a.1.1 0 1 0 0-.3.1.1 0 0 0 0 .3m.8 0a.1.1 0 1 0 0-.3.1.1 0 0 0 0 .3m-.5.3a.1.1 0 1 0 0-.3.1.1 0 0 0 0 .3m-.3.4a.1.1 0 1 0 0-.3.1.1 0 0 0 0 .3m.8 0a.1.1 0 1 0 0-.3.1.1 0 0 0 0 .3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#039",
    d: "m21 22.5.4.7h.3q.3 0 .4-.2t.2-.5v-1H21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21.3 22a.1.1 0 1 0 0-.2.1.1 0 0 0 0 .2m.7 0a.1.1 0 1 0 0-.2.1.1 0 0 0 0 .2m-.3.4a.1.1 0 1 0 0-.3.1.1 0 0 0 0 .3m-.4.4a.1.1 0 1 0 0-.3.1.1 0 0 0 0 .3m.7 0a.1.1 0 1 0 0-.3.1.1 0 0 0 0 .3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.3 0h53.3v40H.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPt);
export default __webpack_public_path__ + "static/media/pt.7b70fda0c0cf3c00d07cfe204dd4249e.svg";
export { ForwardRef as ReactComponent };